import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppBar, Box, IconButton, Toolbar, Typography, Drawer } from '@material-ui/core';
import { experimentalStyled } from '@material-ui/core/styles';
import type { AppBarProps } from '@material-ui/core';
import MenuIcon from '../../icons/Menu';
import AccountPopover from './AccountPopover';
import ContactsPopover from './ContactsPopover';
import ContentSearch from './ContentSearch';
import LanguagePopover from './LanguagePopover';
import Logo from '../Logo';
import NotificationsPopover from './NotificationsPopover';
import UEHLogo from '../UEHLogo'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import type { Theme } from '@material-ui/core';
import '../../css/Header.scss'

interface IFooterInfo {
  SettingName: string,
  SettingStringData: string
}

interface DashboardNavbarProps extends AppBarProps {
  onSidebarMobileOpen?: () => void;
  headerData: IFooterInfo[];
}

const DashboardNavbarRoot = experimentalStyled(AppBar)(
  ({ theme }) => (
    {
      ...(
        theme.palette.mode === 'light' && {
          backgroundColor: theme.palette.primary.main,
          boxShadow: 'none',
          color: theme.palette.primary.contrastText,
        }
      ),
      ...(
        theme.palette.mode === 'dark' && {
          backgroundColor: theme.palette.background.paper,
          boxShadow: 'none',
          borderBottom: `1px solid ${theme.palette.divider}`,
        }
      ),
      zIndex: theme.zIndex.drawer + 100
    }
  )
);

const DashboardNavbar: FC<DashboardNavbarProps> = (props) => {
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
  const { onSidebarMobileOpen, headerData, ...other } = props;
  let name;
  if (headerData.length > 0) {
    headerData.map(el => {
      if (el.SettingName == "TenTruong") {
        name = el.SettingStringData;
      }
    })
  }
  const content = (
    <DashboardNavbarRoot className="psc-navbar" {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        <IconButton
          color="inherit"
          onClick={onSidebarMobileOpen}
          sx={{
            display: {
              lg: 'none'
            }
          }}
        >
          <MenuIcon fontSize="small" />
        </IconButton>
        <RouterLink to="/">
          {/* <Logo
            sx={{
              display: {
                lg: 'inline',
                xs: 'none'
              },
              height: 40,
              width: 40
            }}
          /> */}
          {/* <UEHLogo
            sx={{
              display: {
                lg: 'inline',
                xs: 'none'
              },
              height: 60,
              width: 60
            }} /> */}
        </RouterLink>
        <Typography
          sx={{
            ml: 2,
            textTransform: 'uppercase',
            display: {
              md: 'inline',
              xs: 'none'
            }
          }}
          align="center"
          justifyContent="center"
          color="#ECEE4D"
          fontWeight={700}
          variant="h4"
        >
          {name}
        </Typography>
        <Box
          sx={{
            flexGrow: 1,
            ml: 2
          }}
        />
        {/* xài đa ngôn ngữ */}
        <LanguagePopover />

        {/* <Box sx={{ ml: 1 }}>
          <ContentSearch />
        </Box> */}
        {/* <Box sx={{ ml: 1 }}>
          <ContactsPopover />
        </Box> */}
        {/* <Box sx={{ ml: 1 }}>
          <NotificationsPopover />
        </Box> */}
        <Box sx={{ ml: 2 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
    </DashboardNavbarRoot>
  )
  if (lgUp) {
    return (
      <Drawer
        anchor="top"
        PaperProps={{
          sx: {
            backgroundColor: 'background.pscdefault',
            left: '280px !important',
            width: 'calc(100% - 280px) !important',
            height: 64
          }
        }}
        variant="permanent"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="top"
      PaperProps={{
        sx: {
          backgroundColor: 'background.pscdefault',
          width: '100% !important',
          height: 64
        }
      }}
      variant="permanent"
    >
      {content}
    </Drawer>
  );
};

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func
};

export default DashboardNavbar;
